import { Component, Input, OnInit } from '@angular/core';
import { FeedbackService } from 'src/core/services/feedback/feedback.service';
import { FeedbackDto } from 'src/core/models/feedback/feedback.dto';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'ca-feedback-detail',
  templateUrl: './feedback-detail.component.html',
  styleUrls: ['./feedback-detail.component.scss'],
  standalone: false,
})
export class FeedbackDetailComponent {
  @Input() set feedbackId(value: number) {
    if (value) {
      this._feedbackId = value;
      this.loadFeedback();
    }
  }
  get feedbackId(): number {
    return this._feedbackId;
  }
  private _feedbackId: number;

  feedback: FeedbackDto | null = null;
  isLoading = false;

  constructor(private feedbackService: FeedbackService, public activeModal: NgbActiveModal) {}

  loadFeedback(): void {
    this.isLoading = true;

    this.feedbackService.getByIdAndMarkAsRead(this.feedbackId).subscribe({
      next: data => {
        this.feedback = data;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  closeModal(): void {
    this.activeModal.dismiss();
  }
}
